/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface ViewRequirementCondition
 */

/**
 * Check if a given object implements the ViewRequirementCondition interface.
 */
export function instanceOfViewRequirementCondition(value) {
  return true;
}
export function ViewRequirementConditionFromJSON(json) {
  return ViewRequirementConditionFromJSONTyped(json, false);
}
export function ViewRequirementConditionFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'startsWith': json['startsWith'] == null ? undefined : json['startsWith'],
    'equals': json['equals'] == null ? undefined : json['equals'],
    'resourceAuthorization': json['resourceAuthorization'] == null ? undefined : json['resourceAuthorization'],
    'contains': json['contains'] == null ? undefined : json['contains']
  };
}
export function ViewRequirementConditionToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'startsWith': value['startsWith'],
    'equals': value['equals'],
    'resourceAuthorization': value['resourceAuthorization'],
    'contains': value['contains']
  };
}